<div
  class="offcanvas offcanvas-start w-225px w-lg-275px w-md-250px"
  tabindex="-1"
  id="settingAdminBar"
  aria-labelledby="settingAdminBarLabel"
>
  <div class="offcanvas-header">
    <a
      class="fs-4 fw-bolder text-gray-900 text-hover-primary lh-1 cursor-pointer"
      >{{"profile.settings" | translate}}</a
    >
    <div
      class="btn btn-sm btn-icon btn-active-light-primary"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    >
      <span class="svg-icon svg-icon-2"></span>
      <span
        [inlineSVG]="'./assets/media/icons/duotune/arrows/arr061.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </div>
  </div>

  <div class="offcanvas-body border">
    <!-- begin::Menu -->
    <div
      class="menu menu-column menu-active-bg menu-hover-bg menu-title-gray-700 fs-6 menu-rounded w-100"
      id="#kt_aside_menu"
      data-kt-menu="true"
    >
      <!--begin::Heading-->
      <div class="menu-item">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-user-group me-2"></i> {{"profile.manage_groups" | translate}}</span
          >
        </div>
        <!--end::Heading-->

        <!--begin::Menu item-->
        <div class="menu-item" *lcmsPermission="['CAN-LIST-GROUPS','||','CAN-MANAGE-GROUPS']">
          <a
            routerLink="/admin/groups"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            class="menu-link" data-bs-dismiss="offcanvas"
          >
            <span class="menu-title ms-4">{{"groups.list_groups" | translate}}</span>
            <!--span class="menu-badge">7</span-->
          </a>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <div class="menu-item" *lcmsPermission="['CAN-ADD-GROUPS','||','CAN-MANAGE-GROUPS']">
          <a
            routerLink="/admin/groups/new"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            class="menu-link" data-bs-dismiss="offcanvas"
          >
            <span class="menu-title ms-4">{{"groups.add"| translate}}</span>
            <!--span class="menu-badge">7</span-->
          </a>
        </div>
        <!--end::Menu item-->

        <!--begin::Menu item-->
        <!-- <div class="menu-item">
          <a
            routerLink="/apps/tickets-system/tag"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            class="menu-link" data-bs-dismiss="offcanvas"
          >
            <span class="menu-title ms-4">{{"MenuDashboard.tags" |translate}}</span>
          </a>
        </div> -->
        <!--end::Menu item-->
      </div>
      <!--end::Heading-->


      <!--begin::Heading-->
      <div class="menu-item"  *lcmsPermission="['CAN-MANAGE-USERS','||','CAN-DISPLAY-USERS','CAN-DISPLAY-USERS-BY-GROUP','CAN-ASSIGN-USERS-TO-GROUP','CAN-ADD-USERS-BY-EXCEL','CAN-ADD-USER']">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder"
            ><i class="fa-solid fa-user me-2"></i> {{"profile.manage_users" | translate}}</span
          >
        </div>
      </div>
      <!--end::Heading-->

      <!--begin::Menu item-->
      <div class="menu-item" *lcmsPermission="['CAN-DISPLAY-USERS','||','CAN-MANAGE-USERS']">
        <a routerLink="/admin/users" class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"profile.users_list" | translate}}</span>
          <!--span class="menu-badge">70</span-->
        </a>
      </div>
      <!--end::Menu item-->

      <!--begin::Menu item-->
      <!-- <div class="menu-item" *lcmsPermission="['CAN-DISPLAY-USERS-BY-GROUP','||','CAN-MANAGE-USERS']">
        <a
          routerLink="/admin/groups/users"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{"MenuDashboard.by_groups" | translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->

      <!--begin::Menu item-->
      <div class="menu-item" *lcmsPermission="['CAN-ADD-USER','||','CAN-MANAGE-USERS']">
        <a routerLink="/admin/inscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"profile.new_user" | translate}}</span>
        </a>
      </div>
      <!--end::Menu item-->
      <!--begin::Menu item-->
      <div class="menu-item" *lcmsPermission="['CAN-ADD-USERS-BY-EXCEL','||','CAN-MANAGE-USERS']">
        <a routerLink="/admin/users/excel/adduser"  class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"Inscription.Inscription_Excel" | translate}}</span>
        </a>
      </div>
      <!--end::Menu item-->
      <!--begin::Menu item-->
      <div class="menu-item" *lcmsPermission="['CAN-ASSIGN-USERS-TO-GROUP','||','CAN-MANAGE-USERS']">
        <a
          routerLink="/admin/groups/users/assign"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{"Inscription.assign_users" | translate}}</span>
        </a>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-TAGS','||','CAN-ADD-TAGS', 'CAN-LIST-TAGS']" >
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder"
            ><i class="fa-solid fa-tag me-2 fs-3"></i> {{'tags.manage'| translate}}</span
          >
        </div>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-TAGS', '||', 'CAN-LIST-TAGS']" >
        <a
          routerLink="/admin/tags/list-tags"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{'tags.list-tags' | translate}}</span>
        </a>
      </div>
      <div class="menu-item"  *lcmsPermission="['CAN-ADD-TAGS','||','CAN-MANAGE-TAGS']" >
        <a
          routerLink="/admin/tags/add-tag"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{'tags.add-tag' | translate}}</span>
        </a>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-EVENT','||','CAN-LIST-EVENT']" >
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder"
            ><i class="fa-regular fa-calendar me-2 fs-3"></i> {{'calendar.event_management'| translate}}</span
          >
        </div>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-EVENT', '||', 'CAN-LIST-EVENT']" >
        <a
          routerLink="calendrier/evenements"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{'calendar.event_list' | translate}}</span>
        </a>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-EVENT', '||', 'CAN-ADD-EVENT']" >
        <a
          routerLink="calendrier/evenements/new"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{'calendar.add_event' | translate}}</span>
        </a>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-NOTIFICATION' ,'||']">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder text-nowrap"
          ><i class="fa-sharp fa-solid fa-bell me-2 fs-3"></i> {{'notification.gestion'| translate}}</span
          >
        </div>
      </div>
      <div class="menu-item"  *lcmsPermission="['CAN-MANAGE-NOTIFICATION' ,'||']" >
        <a
          routerLink="centre-notifications"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4"> {{'notification.center-notification'| translate}}</span>
        </a>
      </div>
      <div class="menu-item"  *lcmsPermission="['CAN-ADD-TEMPLATE' ,'||' , 'CAN-MANAGE-TEMPLATE']" >
        <a
          routerLink="centre-notifications/template"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4"> {{'notification.addTemplates'| translate}}</span>
        </a>
      </div>
      <div class="menu-item"  *lcmsPermission="['CAN-MANAGE-TEMPLATE' ,'||' , 'CAN-LIST-TEMPLATE']" >
        <a
          routerLink="centre-notifications/list-template"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4"> {{'notification.listTemplates'| translate}}</span>
        </a>
      </div>
      <div *lcmsPermission="['CAN-ADD-ARTICLE']" class="menu-item" >
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-circle-question me-2 fs-3"></i>{{'faq.gestion'| translate}}</span
          >
        </div>
      </div>
      <div *lcmsPermission="['CAN-ADD-ARTICLE']" class="menu-item"  >
        <a
          routerLink="/admin/add-question"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
<!--          {{'calendar.event_list' | translate}}-->
          <span class="menu-title ms-4"> {{'faq.add'| translate}}</span>
        </a>
      </div>


      <!-- Manage permissions -->

      <!-- <div class="menu-item"> -->
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-PERMISSION']">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-shield-halved me-2 fs-3"></i>
            {{"PERMISSIONS.MANAGE_PERMISSIONS"| translate}}</span
          >
        </div>
      </div>

      <!--begin::Menu item-->
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-PERMISSION']">
        <a
          routerLink="/permissions"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4 text-nowrap">{{"PERMISSIONS.MANAGE_PERMISSIONS" | translate}}</span>
        </a>
      </div>

      <!--end::Menu item-->
      <!--end::Menu item-->

      <!-- Manage archivage -->
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-ARCHIVAGE']">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-shield-halved me-2 fs-3"></i>
            {{"Archive.manage"| translate}}</span
          >
        </div>
      </div>

      <!--begin::Menu item-->
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-ARCHIVAGE']">
        <a
          routerLink="/archives"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4 text-nowrap">{{"Archive.archive_list" | translate}}</span>
        </a>
      </div>
<!--      Survey creator-->
<div class="menu-item"  *lcmsPermission="['CAN-MANAGE-SURVEY','||','CAN-ADD-SURVEY','||','CAN-MANAGE-REPORT-SURVEY','||','CAN-LIST-SURVEY']">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-book-open-reader me-2 fs-3"></i>
            {{"Survey.listTitle"| translate}}</span
          >
        </div>
      </div>

      <!--begin::Menu item-->
      <!-- <div class="menu-item" *lcmsPermission="['CAN-MANAGE-SURVEY' , '||' ,'CAN-LIST-SURVEY','||','CAN-MANAGE-REPORT-SURVEY','||','CAN-ADD-SURVEY']"> -->
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-SURVEY','||','CAN-LIST-SURVEY']">
        <a
          routerLink="/survey"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4 text-nowrap">{{"Survey.listSurvey" | translate}}</span>
        </a>
      </div>
<!--      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-ELEMENT' , '||' ,'CAN-LIST-ELEMENT' ,'CAN-MANAGE-SURVEY']">-->
<!--        <a-->
<!--          routerLink="/survey/question/-1"-->
<!--          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"-->
<!--          class="menu-link" data-bs-dismiss="offcanvas"-->
<!--        >-->
<!--          <span class="menu-title ms-4 text-nowrap">{{"Survey.ListElements" | translate}}</span>-->
<!--        </a>-->
<!--      </div>-->
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-SURVEY' , '||' ,'CAN-ADD-SURVEY']">
        <a
          routerLink="/survey/creator"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4 text-nowrap">{{"Survey.AddSr" | translate}}</span>
        </a>
      </div>
      <div class="menu-item" *lcmsPermission="['CAN-MANAGE-SURVEY' , '||','CAN-MANAGE-REPORT-SURVEY']">
        <a
          routerLink="/admin/stats"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4 text-nowrap">{{'report.statistique' |translate}}</span>
        </a>
      </div>
<!--end survey-->
      <!--end::Menu item-->

      <!--begin::Menu item-->
      <!-- <div class="menu-item" *lcmsPermission="'CAN-ASSIGN-PERMISSION'">
        <a
          routerLink="/admin/visibility"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{"Visibility.permissions" | translate}}</span>
        </a>
      </div>
      <div class="menu-item">
        <a
          routerLink="/admin/users/enroler"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{"catalogue.enroll" | translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->

      <!--begin::Menu item-->
      <!-- <div class="menu-item">
        <a
          routerLink="/apps/tickets-system/tag"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link" data-bs-dismiss="offcanvas"
        >
          <span class="menu-title ms-4">{{"MenuDashboard.desatived" | translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->
      <!--begin::Heading-->
      <!-- <div class="menu-item">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-envelope me-2"></i>{{"MenuDashboard.Notifications" | translate}}</span
          >
        </div>
      </div> -->
      <!--end::Heading-->

      <!--begin::Menu item-->
      <!-- <div class="menu-item">
        <a routerLink="/admin/groups" class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"MenuDashboard.SMS" |translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->
      <!--begin::Menu item-->
      <!-- <div class="menu-item">
        <a routerLink="/admin/groups" class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"AUTH.INPUT.EMAIL" | translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->
      <!--begin::Heading-->
      <!-- <div class="menu-item">
        <div class="menu-content ps-0 pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bolder">
            <i class="fa-solid fa-file-circle-question me-2"></i
            >{{"MenuDashboard.Evaluations" | translate}}</span
          >
        </div>
      </div> -->
      <!--end::Heading-->

      <!--begin::Menu item-->
      <!-- <div class="menu-item">
        <a routerLink="/admin/groups" class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"MenuDashboard.addSpec" | translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->
      <!--begin::Menu item-->
      <!-- <div class="menu-item">
        <a routerLink="/admin/groups" class="menu-link" data-bs-dismiss="offcanvas">
          <span class="menu-title ms-4">{{"MenuDashboard.workflowCreation"  | translate}}</span>
        </a>
      </div> -->
      <!--end::Menu item-->
    </div>
    <!-- end::Menu -->
  </div>
</div>
